import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { UserAdd, UserEdit } from 'components/forms/UserAdd';

import useUser from 'hooks/useUser';
import UsersList from './UsersList';

const Users: React.FC = () => {
  const { isBdataAmin, isAbaAdmin, isBcAdmin } = useUser();

  return (
    <Routes>
      <Route path="/" element={<UsersList />} />
      {(isBdataAmin || isBcAdmin) && (
      <Route path="new" element={<UserAdd />} />
      )}
      {(isBdataAmin || isAbaAdmin || isBcAdmin) && (
      <Route path=":id/*" element={<UserEdit />} />
      )}
    </Routes>
  );
};

export default Users;
